import { Children } from 'react';
import type { MouseEventHandler, ReactNode } from 'react';
import { BuildingOfficeIcon } from '@phosphor-icons/react';
import styles from './StoreList.module.scss';
import SimpleButton from '_components/UI/SimpleButton';
import { useStoresUI } from '@context/StoresContext';

export type PdpStoreListProps = {
  titleId: string;
  title: string;
  checkAllStoresLabel: string;
  onCheckAllStoresClick: MouseEventHandler<HTMLButtonElement>;
  /** Rendered inside `<ul>` when `emptyState` is not passed. */
  children?: ReactNode;
  emptyState?: ReactNode;
};

const PdpStoreList = ({
  titleId,
  title,
  checkAllStoresLabel,
  onCheckAllStoresClick,
  children,
  emptyState,
}: PdpStoreListProps) => {
  const hasChildren = Children.count(children) > 0;
  const { favouriteStoreDetails } = useStoresUI();

  return (
    <section className={styles.root} aria-labelledby={titleId}>
      <header className={styles.header}>
        <div className={styles.titleGroup}>
          <BuildingOfficeIcon
            aria-hidden="true"
            size={20}
            weight="regular"
            color="var(--neutrals-1000)"
          />
          <h2 className={styles.title} id={titleId}>
            {title}
          </h2>
        </div>
        {favouriteStoreDetails && (
          <SimpleButton
            className={styles.checkAllLink}
            onClick={onCheckAllStoresClick}
            variant="secondary"
          >
            {checkAllStoresLabel}
          </SimpleButton>
        )}
      </header>
      {emptyState ? (
        <div className={styles.emptyBody}>{emptyState}</div>
      ) : hasChildren ? (
        <ul className={styles.list}>{children}</ul>
      ) : null}
    </section>
  );
};

export default PdpStoreList;
